module.exports = __webpack_public_path__ + "img/Icone_100.ad2b9a32.svg";